import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CardHeader from '@material-ui/core/CardHeader'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import Avatar from '@material-ui/core/Avatar'
import Grid from '@material-ui/core/Grid'
import ActionsTableComponent from './ActionsTableComponent'
import { calculsTransaction, calculCycle } from 'utils/PriceCalculHelpers'
import Typography from '@material-ui/core/Typography'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import WatchIcon from '@material-ui/icons/WatchLater'
import EuroIcon from '@material-ui/icons/EuroSymbol'
import GroupIcon from '@material-ui/icons/Group'
import NotifIcon from '@material-ui/icons/Notifications'
import SwapIcon from '@material-ui/icons/SwapHoriz'
import BarIcon from '@material-ui/icons/LocalBar'
import NoNotifIcon from '@material-ui/icons/NotificationsOff'
import moment from 'moment'
import { tableTypesMatcher } from 'utils/labelMatcher'
import { getTableIcon } from 'utils/iconMatcher'
import CycleComponent from './CycleComponent'
import * as Colors from '@material-ui/core/colors'
const runningColor = Colors.lightGreen['500']
const pauseColor = Colors.orange['400']
// import MemberInfo from 'components/MemberComponents/MemberInfo'
const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  cyclesContainer: {
    overflow: 'auto',
    height: 'calc(100% - 200px)'
  },
  card: {
    paddingBottom: 0
  },
  actions: {
    display: 'flex'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: 'auto'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatarPause: {
    width: '50px',
    height: '50px',
    backgroundColor: pauseColor
  },
  avatarRunning: {
    width: '50px',
    height: '50px',
    backgroundColor: runningColor
  },
  actionCard: {
    flex: '0 1 auto'
  }
})

class TableInfo extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    pricings: PropTypes.array.isRequired,
    players: PropTypes.array.isRequired,
    prepareForPayment: PropTypes.func.isRequired,
    playTransaction: PropTypes.func.isRequired,
    pauseTransaction: PropTypes.func.isRequired,
    updateCyclePricing: PropTypes.func.isRequired,
    updateCyclePlayers: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired
  }
  state = {
    elapsed: 0,
    total: '0.00',
    totalConsos: '0.00',
    playersCount: 0,
    currentCycleTotal: '0.00',
    currentCycleElapsed: '-',
    expandedCycle: void 0
  }
  updateState = props => {
    if (props.transaction) {
      const totals = calculsTransaction(props.transaction)
      const currentCycle = calculCycle(
        props.transaction.pool.cycles[props.transaction.pool.cycles.length - 1]
      )
      const newState = {
        elapsed: totals.elapsed,
        total: totals.total.toFixed(2),
        totalConsos: totals.totalProducts.toFixed(2),
        playersCount: totals.playersCount,
        currentCycleTotal: currentCycle.total.toFixed(2),
        currentCycleElapsed: moment(currentCycle.elapsed)
          .utc()
          .format('HH:mm:ss')
      }
      this.setState(newState)
    }
  }
  handleExpand = key => {
    this.setState({
      expandedCycle: this.state.expandedCycle === key ? void 0 : key
    })
  }
  handleCyclePricingChange = (key, pricing) => {
    this.props.updateCyclePricing(this.props.transaction, key, pricing)
  }
  handleCyclePlayersChange = (key, players) => {
    this.props.updateCyclePlayers(this.props.transaction, key, players)
  }
  componentWillMount() {
    const { transaction } = this.props
    if (!transaction.pool.isPaused) {
      this.launchTimer()
    } else {
      this.updateState(this.props)
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer)
    this.timer = null
  }
  componentWillReceiveProps(nextProps) {
    if (
      !this.props.transaction.pool.isPaused &&
      nextProps.transaction.pool.isPaused
    ) {
      clearInterval(this.timer)
      this.updateState(nextProps)
    } else if (
      this.props.transaction.pool.isPaused &&
      !nextProps.transaction.pool.isPaused
    ) {
      this.launchTimer()
    }
  }
  // function starting the timer
  launchTimer() {
    // Initial calculation for elapsed time
    this.tick()
    // Setup the timer to update every second the elapsed time
    this.timer = setInterval(this.tick, 1000)
  }
  // Update State function
  tick = () => {
    this.updateState(this.props)
  }

  // Click on Pause Button
  pause = () => {
    this.props.pauseTransaction(this.props.transaction)
  }

  // Click on Play Button
  play = () => {
    this.props.playTransaction(this.props.transaction)
  }
  render() {
    const { classes, transaction, pricings, players } = this.props
    const { table } = transaction.pool
    if (!table) return null
    const { total, totalConsos, elapsed, playersCount } = this.state
    const color = transaction.pool.isPaused ? pauseColor : runningColor
    const cycles = [...transaction.pool.cycles].reverse()
    return (
      <Card className={classes.container}>
        <CardHeader
          classes={{ action: classes.actionCard }}
          title={<Typography variant="title">{table.name}</Typography>}
          subheader={tableTypesMatcher(table.type)}
          action={
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center">
              <Grid item>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <EuroIcon style={{ color }} color="inherit" />
                    </ListItemIcon>
                    <ListItemText
                      style={{ color }}
                      primary={
                        <Typography style={{ color }} variant="title">
                          {total.toString()}
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <WatchIcon style={{ color }} color="inherit" />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      style={{ color }}
                      primary={moment(elapsed)
                        .utc()
                        .format('HH:mm:ss')}
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <BarIcon style={{ color }} color="inherit" />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      style={{ color }}
                      primary={totalConsos}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <SwapIcon style={{ color }} color="inherit" />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      style={{ color }}
                      primary={
                        transaction.pool.transfert
                          ? Number(transaction.pool.transfert.total).toFixed(2)
                          : '0.00'
                      }
                    />
                  </ListItem>
                </List>
              </Grid>
              <Grid item>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <GroupIcon style={{ color }} color="inherit" />
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      style={{ color }}
                      primary={playersCount || '0'}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      {transaction.pool.alert ? (
                        <NotifIcon style={{ color }} color="inherit" />
                      ) : (
                        <NoNotifIcon style={{ color }} color="inherit" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      disableTypography
                      style={{ color }}
                      primary={
                        transaction.pool.alert
                          ? moment(
                              moment(transaction.pool.alert).diff(moment())
                            )
                              .utc()
                              .format('HH:mm:ss')
                          : '-'
                      }
                    />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          }
          avatar={
            <Avatar
              className={
                transaction.pool.isPaused
                  ? classes.avatarPause
                  : classes.avatarRunning
              }>
              {getTableIcon(table.type)}
            </Avatar>
          }
        />
        <Divider />
        <ActionsTableComponent
          transaction={transaction}
          showModal={this.props.showModal}
          prepareForPayment={this.props.prepareForPayment}
          playTransaction={this.props.playTransaction}
          pauseTransaction={this.props.pauseTransaction}
        />
        <Divider />
        {
          <div className={classes.cyclesContainer}>
            {cycles.map((cycle, index) => (
              <CycleComponent
                key={cycle.key}
                index={cycle.key}
                pricings={pricings}
                players={players}
                onExpand={this.handleExpand}
                updateCyclePricing={this.handleCyclePricingChange}
                updateCyclePlayers={this.handleCyclePlayersChange}
                cycle={cycle}
                count={cycles.length}
                expanded={this.state.expandedCycle === cycle.key}
                isLast={cycles.length - 1 === cycle.key}
                total={
                  cycles.length - 1 === cycle.key
                    ? this.state.currentCycleTotal
                    : null
                }
                elapsed={
                  cycles.length - 1 === cycle.key
                    ? this.state.currentCycleElapsed
                    : null
                }
                showModal={this.props.showModal}
              />
            ))}
          </div>
        }
      </Card>
    )
  }
}

export default withStyles(styles)(TableInfo)



// WEBPACK FOOTER //
// ./src/routes/Table/components/TableInfo.js